import { inject, Pipe, PipeTransform } from '@angular/core';
import { SvcAppSettings } from '@solvace/common/settings/svc-app-settings';

@Pipe({
  name: 'formatNumberDefault',
})
export class FormatNumberDefaultPipe implements PipeTransform {
  private get decimalSymbol(): string {
    return this.#svcAppSettings.delimiterSymbol;
  }
  private get thousandsSymbol(): string {
    return this.#svcAppSettings.delimiterSymbol === ',' ? '.' : ',';
  }

  #svcAppSettings = inject(SvcAppSettings);

  transform(value: number, forceDecimal: boolean = false): string {
    if (value || forceDecimal) {
      value = value ?? 0;
      const integerValue = Math.floor(value);
      const decimalValue = ((): number => {
        const diff = value - integerValue;
        return diff > 0 ? parseInt(diff.toFixed(2).split('.')[1]) : 0;
      })();
      const integerStr = ((): string => {
        let numberStr = integerValue.toString();
        if (numberStr.length > 3) {
          for (let i = numberStr.length - 3; i >= 1; i -= 3) {
            numberStr = numberStr.slice(0, i) + this.thousandsSymbol + numberStr.slice(i);
          }
        }
        return numberStr;
      })();
      const decimalStr = decimalValue || forceDecimal ? this.decimalSymbol + (decimalValue ?? 0).toString().padEnd(2, '0') : '';
      return integerStr + decimalStr;
    }
    return value?.toString() ?? '';
  }
}
